module.exports = __webpack_public_path__ + "img/radiaIcon5.6a73001b.png";